import { LayoutHierarchyFilteringState } from './filtering-state';

// Currently nothing really happens here; we just arbitrarily pick the first actual level. This function exists to
//   provide a single "find all usages" point to start at once we decide to make this smarter.
export function pickSingleActiveLevelGuid(choices: string[]): LayoutHierarchyFilteringState['activeLevelGuid'] {
  return choices[0] ?? null;
}
